// import * as Firebase from "firebase/app";
import { initializeApp, getApp, getApps, deleteApp } from "firebase/app";
import { getFirestore, enableMultiTabIndexedDbPersistence, terminate } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, signOut, setPersistence, browserLocalPersistence, signInWithCustomToken } from "firebase/auth";
import { checkLoginDetailsApi } from "./api";
import { async } from "@firebase/util";
import { useHistory } from "react-router-dom";
import AppConfig from "../config/app-config";
import { getUser } from "../query/users.query";
import axios from "axios";
import DeviceDataService from "./device-data";
import LampDataService from "./lamps-data";
import DeviceAddressService from "./device-address";
import PoleDataService from "./pole-data";
import { v4 as uuidv4 } from 'uuid';
const TAG = "[AUTH] => ";
var defaultConfig = null;
var defaultFirebaseApp = null;
var defaultFirebaseAuth = null;
var defaultFirebaseFirestore = null;

var serviceConfig = null;
var serviceFirebaseApp = null;
var serviceFirebaseAuth = null;
var serviceFirebaseFirestore = null;
var isAdmin = false;

/// MASTER | DEFAULT ACCOUNT

const setIsAuthorized = (status) => {
    localStorage.setItem("isAuthenticated", status);
}

const getIsAuthorized = () => {
    return localStorage.getItem("isAuthenticated") || false;
}

const setUserName = (userName) => {
    localStorage.setItem("userEmail", userName);
}

const getUserName = () => {
    let userName = localStorage.getItem("userEmail");
    if (userName == null || userName == "") {
        return Promise.reject("User name not found");
    }
    return Promise.resolve(userName);
}

const setUserAccessList = (accessList) => {
    // debugger;
    if (accessList === undefined || accessList === null ) {
        localStorage.removeItem("userAccessList");
        return;
    }
    let accessListString = JSON.stringify(accessList);
    localStorage.setItem("userAccessList", accessListString);
}

const checkUserAccess = (access) => {
    // debugger;
    let userAccessListString = localStorage.getItem("userAccessList");
    if (userAccessListString === undefined || userAccessListString === null || userAccessListString === "") {
        return false;
    }
    let userAccessList = JSON.parse(userAccessListString) || [];

    const accessItem = userAccessList.find(i => i === access);
    if (accessItem == undefined || accessItem == null || accessItem == "") {
        return false;
    }
    return true;
}

const setIsAdmin = (status) => {
    isAdmin = status;
    localStorage.setItem("isAdmin", status);
}

const getIsAdmin = () => {
    if (isAdmin === undefined || isAdmin === null || isAdmin === false) {
        let stored = localStorage.getItem("isAdmin");
        if (stored === "true") return true;
        if (stored === "false") return false;
    }
    return isAdmin;
}

const getMasterConfig = async () => {
    let config = await fetch("/__/firebase/init.json")
        .then(function (res) {
            return Promise.resolve(res.json());
        })
        .then(function (data) {
            return Promise.resolve(data);
        })
        .catch(function (err) {
            console.log(`error = ${err}`);
        });
        let data = AppConfig.DEFAULT_CONFIG;
        if (AppConfig.DEFAULT_CONFIG === null || AppConfig.DEFAULT_CONFIG === "") {
            return Promise.reject("Unable to get firebase configuration");
        }
    return Promise.resolve(JSON.parse(AppConfig.DEFAULT_CONFIG)); //Comment on prod
};

const initMasterFirebase = async () => {
    defaultConfig = await getMasterConfig().catch((error) => {
        return Promise.reject(error);
    });
    if (defaultConfig != null) {
        try {
            defaultFirebaseApp = initializeApp(defaultConfig);
            // defaultFirebaseApp = initializeApp(JSON.parse(defaultConfig));
        } catch (e) {
            console.log(`${TAG} Unable to default config error = ${e}`);
            return Promise.reject("Unable to default config");
            // firebaseApp = getApp();
        }
    } else {
        console.log(`${TAG} Unable to default config`);
        return Promise.reject("Unable to default config");
    }
    defaultFirebaseFirestore = getFirestore(defaultFirebaseApp);
    enableMultiTabIndexedDbPersistence(defaultFirebaseFirestore).catch((err) => {
        console.log(`${TAG} Persistence init error:`, err);
    });
    defaultFirebaseAuth = getAuth(defaultFirebaseApp);
    await setPersistence(defaultFirebaseAuth, browserLocalPersistence)
        .then(() => {
            
        })
        .catch((error) => {
            // return false;
        });
    Promise.resolve();
};

const getMasterAuth = async() => {
    if (defaultFirebaseAuth) {
        return Promise.resolve(defaultFirebaseAuth);
    }
    let firebaseApp = await initMasterFirebase().catch((error) => {
        return Promise.reject(error);
    })
    if (defaultFirebaseAuth) {
        return Promise.resolve(defaultFirebaseAuth);
    } else {
        return Promise.reject("Unable to get Auth");
    }
}

const getMasterFirestore = async() => {
    if (defaultFirebaseFirestore) {
        return Promise.resolve(defaultFirebaseFirestore);
    }
    let firebaseApp = await initMasterFirebase().catch((error) => {
        return Promise.reject(error);
    })
    if (defaultFirebaseFirestore) {
        return Promise.resolve(defaultFirebaseFirestore);
    } else {
        return Promise.reject("Unable to get firestore");
    }
}

const logInWithEmailAndPassword = async (email, password) => {
    
    // try {
        // let res = setPersistence(auth, browserSessionPersistence)
        let auth = await getMasterAuth().catch((error) => {
            return Promise.reject(error);
        });

        // authenticate with main firebase
        let userCredentials = await signInWithEmailAndPassword(auth, email, password).catch((error) => {
            return Promise.reject(error);
        });

        return Promise.resolve(userCredentials.user);
    // } catch (error) {
    //     console.log(error);
    //     return Promise.reject(error);
    // }
};

const getIdToken = async (userCredentials) => {
    if (userCredentials === null) {
        return Promise.reject("Invalid user credentials");
    }
    // get ID token
    let idTokenRes = await userCredentials.getIdTokenResult(true).catch((error) => {
        return Promise.reject(error);
    });

    //check is ID token exist
    if (idTokenRes == null || idTokenRes.token == null || idTokenRes.token == "") {
        return Promise.reject("Unable to get ID Token");
    }

    return Promise.resolve(idTokenRes.token);
};

const checkMasterSession = async () => {
    let auth = await getMasterAuth().catch((error) => {
        return Promise.reject(error);
    });

    if (auth == null || auth.currentUser == null) {
        return Promise.reject("Invalid session");
    }

    return Promise.resolve(auth.currentUser);
}
 

const masterLogout = async () => {
    await logout();
    if (defaultFirebaseAuth != null) {
        await signOut(defaultFirebaseAuth);
    }
    setIsAuthorized(false);
    setUserName("");
    setUserAccessList(null);
    defaultConfig = null;
    defaultFirebaseApp = null;
    defaultFirebaseAuth = null;
    defaultFirebaseFirestore = null;
};

/// SERVICE ACCOUNT

const getServiceCustomToken = async (idToken, dbName) => {
    let url = AppConfig.GET_CUSTOM_TOKEN;
    url = url.replace("#IDTOKEN#",idToken);
    url = url.replace("#DBNAME#",dbName);
    
    let responseData = null;
    await axios
        .get(url)
        .then((response) => {
            const { status, data = null } = response;
            if (status === 200) {
                responseData = data;
            }
            console.log("response : ", responseData);
        })
        .catch((err) => {
            console.log("error : ", err);
            Promise.reject(err);
        });
    if (responseData != null) {
        return Promise.resolve(responseData);
    } else {
        Promise.reject("Unable to get token");
    }
};

const setServiceConfig = async (config) => {
    localStorage.setItem("firebaseConfigApiResponse", JSON.stringify(config));
};

const getServiceConfig = async () => {
    const firebaseConfigApiResponse = localStorage.getItem("firebaseConfigApiResponse");
    if (firebaseConfigApiResponse) {
        return firebaseConfigApiResponse;
    }
    return null;
};


const initServiceFirebase = async () => {

    if (serviceFirebaseApp === null) {
        serviceConfig = await getServiceConfig();
        if (serviceConfig != null && serviceConfig !== "undefined" && serviceConfig !== "[object Object]") {
            try {
                const parsedConfig = JSON.parse(serviceConfig);
                const appName = parsedConfig.projectId || parsedConfig.authDomain || "defaultApp";
                
                const existingApp = getApps().find((app) => app.name === appName);
                if (existingApp) {
                    console.log(`${TAG} Reusing existing Firebase App instance for project [${appName}]`);
                    serviceFirebaseApp = existingApp;
                } else {
                    console.log(`${TAG} Initializing new Firebase App instance for project [${appName}]`);
                    serviceFirebaseApp = initializeApp(parsedConfig, appName);
                    localStorage.setItem("serviceFirebaseApp", appName);
                }
            } catch (e) {
                console.error(`${TAG} Error initializing Firebase App:`, e);
                return Promise.reject("Unable to config");
            }

        } else {
            console.log(`${TAG} Unable to config - serviceConfig is null`);
            return Promise.reject("Unable to config");
        }
    }

    if (serviceFirebaseApp === null) {
        return Promise.reject("Unable to config");
    }
    serviceFirebaseFirestore = getFirestore(serviceFirebaseApp);
    enableMultiTabIndexedDbPersistence(serviceFirebaseFirestore).catch((err) => {
        console.log(`${TAG} Persistence init status [${serviceFirebaseApp.name}]:`, err.code || err.message || err);
    });
    serviceFirebaseAuth = getAuth(serviceFirebaseApp);
    await setPersistence(serviceFirebaseAuth, browserLocalPersistence)
            .then(() => {
                
            })
            .catch((error) => {
                // return false;
            });
    return Promise.resolve(serviceFirebaseApp);
};

const getServiceAuth = async() => {
    if (serviceFirebaseAuth) {
        return Promise.resolve(serviceFirebaseAuth);
    }
    let firebaseApp = await initServiceFirebase().catch((error) => {
        return Promise.reject(error);
    })
    if (serviceFirebaseAuth) {
        return Promise.resolve(serviceFirebaseAuth);
    } else {
        return Promise.reject("Unable to get Auth");
    }
}

const getServiceFirestore = async() => {
    if (serviceFirebaseFirestore) {
        return Promise.resolve(serviceFirebaseFirestore);
    }
    let firebaseApp = await initServiceFirebase().catch((error) => {
        return Promise.reject(error);
    })
    if (serviceFirebaseFirestore) {
        return Promise.resolve(serviceFirebaseFirestore);
    } else {
        return Promise.reject("Unable to get firestore");
    }
}

// const logInWithEmailAndPassword = async (email, password) => {
//     try {
//         // let res = setPersistence(auth, browserSessionPersistence)
//         let res = setPersistence(auth, browserLocalPersistence)
//             .then(() => {
//                 return signInWithEmailAndPassword(auth, email, password);
//             })
//             .catch((error) => {
//                 return false;
//             });

//         return res;
//     } catch (err) {
//         console.error(err);
//         return false;
//     }
// };

const logInWithCustomToken = async (token) => {
    let auth = await getServiceAuth().catch((error) => {
        return Promise.reject(error);
    });

    // authenticate with main firebase
    let userCredentials = await signInWithCustomToken(auth, token).catch((error) => {
        return Promise.reject(error);
    });

    return Promise.resolve(userCredentials);
};



const logout = async () => {
    const appName = localStorage.getItem("serviceFirebaseApp");
    const existingApp = serviceFirebaseApp || (appName ? getApps().find((app) => app.name === appName) : null);

    console.log(`${TAG} Logging out & deinitializing services for active app [${existingApp ? existingApp.name : 'none'}]`);

    if (existingApp != null) {
        try {
            const db = getFirestore(existingApp);
            if (db) {
                await terminate(db);
                console.log(`${TAG} Terminated Firestore for app [${existingApp.name}]`);
            }
        } catch (e) {
            console.warn(`${TAG} Error terminating firestore:`, e);
        }
    }

    if (serviceFirebaseAuth != null) {
        try {
            await signOut(serviceFirebaseAuth);
        } catch (e) {}
    }
    if (existingApp != null) {
        try {
            await deleteApp(existingApp);
        } catch (e) {}
    }
    serviceFirebaseApp = null;
    DeviceAddressService.deinit();
    DeviceDataService.deinit();
    LampDataService.deinit();
    PoleDataService.deinit();
    localStorage.removeItem("firebaseConfigApiResponse");
    localStorage.removeItem("serviceFirebaseApp");
    setIsAuthorized(false);
    serviceConfig = null;
    serviceFirebaseApp = null;
    serviceFirebaseAuth = null;
    serviceFirebaseFirestore = null;
    isAdmin = false;
};

const getCheckSession = async () => {
    var result = true;
    if (serviceFirebaseAuth === null) {
        await initServiceFirebase().then(async () => {
            if (serviceFirebaseApp) {
                serviceFirebaseAuth = getAuth(serviceFirebaseApp);
                serviceFirebaseFirestore = getFirestore(serviceFirebaseApp);
            }
        }).catch((e) => {
            result = false;
            // Promise.reject(e);
        })
    } 
    
    if (result) {
        // let mainObj = getAuth(getApp());
        // const user = mainObj != null ? mainObj.currentUser : null;
        const user = serviceFirebaseAuth ? serviceFirebaseAuth.currentUser : null;

        if (user) {
        // User is signed in, see docs for a list of available properties
            let email = getUserName().catch((error) => {});
            if (!email) {
                result = false;
            }
            
            if (getIsAuthorized() === false) {
                result = false;
            }

            let firebaseConfigApiResponse = localStorage.getItem("firebaseConfigApiResponse");
            if (!firebaseConfigApiResponse || firebaseConfigApiResponse === "undefined" || firebaseConfigApiResponse === "[object Object]") {
                result = false;
            }
        } else {
            // No user is signed in.
            result = false;
        }
    }

    if (result) {
        // Promise.resolve();
    } else {
        await logout();
        // Promise.reject(Error("No user Found"));
    }
    return result;
};

const db = () => {
    console.log("get firebase db instance -> ", serviceFirebaseFirestore);
    return serviceFirebaseFirestore;
}

export { 
    getIsAuthorized,
    setIsAuthorized,
    setUserName,
    getUserName, 
    setUserAccessList,
    checkUserAccess, 
    setIsAdmin,
    getIsAdmin,
    checkMasterSession, 
    masterLogout, 
    getMasterFirestore as getDefaultFirestore, 
    getIdToken,
    getServiceCustomToken, 
    setServiceConfig, 
    db, 
    getCheckSession, 
    logInWithEmailAndPassword,
    logInWithCustomToken,
    logout };